import lib from '@/library'
import store from '@/store'
import config from '@/config'
import mobileBridge from '@/library/mobileBridge'

function handleGame (headline, isLoggedIn) {
  const isNotLoggedIn = !isLoggedIn
  if (isNotLoggedIn) {
    store.dispatch('overlayState/activateLoginDialog')
    return
  }
  startGame(headline)
}

async function startGame (headline) {
  try {
    const response = await getToken()
    const token = response && response.result && response.result.token
    const gameURL = `${headline && headline.bodytext}?token=${token}`
    openLink(gameURL)
  } catch (error) {
    const errorMessage = error.message
    console.log(`free2PlayGamesService.startGame | ERROR | ${errorMessage}`)
  }
}

function openLink (gameURL) {
  console.log(gameURL)
  const isMobileApp = config.app.autoconf.MOBILE_LS
  if (isMobileApp) {
    mobileBridge.bridgeSendRequest('openIgtPay', gameURL)
    return
  }
  window.open(gameURL)
}

async function getToken () {
  try {
    const token = await lib.rpcService.callBroker('xtremepush', 'getjwt')
    return token
  } catch (error) {
    const errorMessage = error.message
    console.log(`free2PlayGamesService.getToken | ERROR | ${errorMessage}`)
  }
}

function checkIsFree2PlayGameHeadline (headline) {
  const ID = headline && headline.title
  const isString = typeof ID === 'string'
  if (!isString) {
    return false
  }
  const isFree2PlayGameHeadline = ID.toLowerCase().includes('free2playgames')
  return isFree2PlayGameHeadline
}

export default {
  handleGame,
  checkIsFree2PlayGameHeadline
}



// WEBPACK FOOTER //
// ./src/library/free2PlayGamesService.js